import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
import { Link } from "@zapier/design-system";
const views = {
    ["DEFAULT"]: () => ({
        bodyText: (_jsxs(Fragment, { children: ["Upgrade to email our world class Support team and we\u2019ll help get you up and running! Or, get", " ", _jsx(Link, { href: "/community", target: "_blank", children: "support from our Community" }), ", for free."] })),
        type: "DEFAULT",
    }),
};
export const getActiveView = () => views.DEFAULT();

// @zapier/upsells@8.0.1 (466b4077f)
